import Warning from "@mui/icons-material/Warning";
import { Chip, SxProps, Tooltip, useTheme } from "@mui/material";

type ThresholdChipProps = {
  isOverThreshold: boolean | null | undefined;
  errorMessage?: string | null;
  loading?: boolean;
  sx?: SxProps;
};

export function ThresholdChip({ isOverThreshold, errorMessage, loading, sx }: ThresholdChipProps) {
  const theme = useTheme();

  if (loading) {
    return (
      <Chip
        label="..."
        size="small"
        variant="filled"
        sx={{
          backgroundColor: theme.palette.action.selected,
          color: theme.palette.text.secondary,
          ...sx,
        }}
      />
    );
  }

  if (isOverThreshold == null) {
    const chip = (
      <Chip
        label="Unknown Threshold"
        size="small"
        variant="filled"
        icon={errorMessage ? <Warning fontSize="small" /> : undefined}
        sx={{
          backgroundColor: theme.palette.action.selected,
          color: theme.palette.text.secondary,
          "& .MuiChip-icon": {
            color: theme.palette.warning.main,
          },
          ...sx,
        }}
      />
    );

    // Wrap with tooltip if there's an error message
    if (errorMessage) {
      return <Tooltip title={errorMessage}>{chip}</Tooltip>;
    }
    return chip;
  }

  // Determinate states (true/false)
  const backgroundColor = isOverThreshold
    ? `${theme.palette.error.light}20`
    : `${theme.palette.success.light}20`;

  const color = isOverThreshold ? theme.palette.error.main : theme.palette.success.main;

  return (
    <Chip
      label={`${isOverThreshold ? "Above" : "Below"} Threshold`}
      size="small"
      variant="filled"
      sx={{
        backgroundColor,
        color,
        ...sx,
      }}
    />
  );
}
